import {Component} from 'react';
import socket from "../../functions/socket";
import localDB from "../../data/localDB";
import connect from "react-redux/es/connect/connect"; 
import { showToast } from "../../actions/ToastAction";
import { salesOpenTable, salesUpdateTable} from "../../actions/SalesTableAction";

export let ws_store = null;

const soundBell = require('../../assets/sounds/bell.mp3');

class SocketStore extends Component {

    async componentDidMount(){
        this.connectProductSocket();
    }

    showToastAlert = (message, type)  => {
        this.props.showToast({ message, type });
    }

    connectProductSocket = () =>{
        try {
            ws_store = socket.store();
            ws_store.onopen = () => {
                console.log('😎 socket_open')
            };
            ws_store.onerror = (err) => {
                console.log('error ')
            };
            ws_store.onmessage = this.messageStoreSocket;
        }catch (err) {
            console.log('error_socket');
        }
    };

    messageStoreSocket = (event) =>{
        try {
            let data = JSON.parse(event.data);
            if(data.message.payload.sender !== localDB.get('user').email){
                if(data.message.payload.type==='category'){
                    if(data.message.payload.action==='save'){
                        localDB.addOrUpdateList('categories', data.message.data);
                    }else if(data.message.payload.action==='delete'){
                        localDB.removeItemList('categories', data.message.data);
                    }
                    this.showToastAlert('Categorías actualizadas!', 'sync');
                }else if(data.message.payload.type==='product'){
                    if(data.message.payload.action==='save'){
                        localDB.addOrUpdateDB('products', data.message.data);
                    }else if(data.message.payload.action==='delete'){
                        localDB.deleteDB('products', data.message.data);
                    }
                    this.showToastAlert('Productos actualizados!', 'sync');
                }else if(data.message.payload.type==='client'){
                    if(data.message.payload.action==='save'){
                        localDB.addOrUpdateDB('clients', data.message.data);
                    }else if(data.message.payload.action==='delete'){
                        localDB.deleteDB('clients', data.message.data);
                    }
                }else if(data.message.payload.type==='provider'){
                    if(data.message.payload.action==='save'){
                        localDB.addOrUpdateDB('providers', data.message.data);
                    }else if(data.message.payload.action==='delete'){
                        localDB.deleteDB('providers', data.message.data);
                    }
                } else if (data.message.payload.type === 'sale') {
                    if (data.message.payload.action === 'open_table') {
                        this.props.salesOpenTable(data.message.data);
                    } else if (data.message.payload.action === 'update_table') {
                        if (data.message.data.from === 'quick_order'){
                            let audio = new Audio(soundBell);
                            audio.play()
                            this.props.salesUpdateTable(data.message.data);
                            this.showToastAlert(`Nuevo pedido en la mesa ${data.message.data.table.number}!`, 'table');
                        }
                    }else if (data.message.payload.action === 'call_center') {
                        let audio = new Audio(soundBell);
                        audio.play()
                        this.showToastAlert(`Nuevo pedido en desde el Call Center!`, 'table');
                    }
                }
            }
        }catch (e) {
            console.log(e)
        }
    };
    render() {
        return null;
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data){
            dispatch(showToast(data))
        },
        salesOpenTable(data){
            dispatch(salesOpenTable(data))
        },
        salesUpdateTable(data){
            dispatch(salesUpdateTable(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(SocketStore);



// WEBPACK FOOTER //
// ./src/components/sockets/SocketStore.js